import styled from "styled-components";
import { color } from "../../../shared/styles";

export const SectionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

interface TitleProps {
    isCollasped?: boolean;
}

export const Title = styled.div<TitleProps>`
    color: ${color.secondary.DARK_GREY};
    font-size: 11px;
    font-weight: 600;
    line-height: 16px;
    padding: 0px 18px 0px 18px;
    letter-spacing: 0.96px;
    white-space: nowrap;
    overflow: hidden;
    text-transform: uppercase;

    ${(props) =>
        props.isCollasped &&
        `
        display: flex;
        justify-content: flex-start;
        padding-left: 8px;
        `}
`;

export const SectionDivider = styled.div`
    width: 32px;
    height: 1px;
    background: #d5d5d5;
`;
